import { createPortal } from "react-dom";

export default function renderHRModal(content) {
  if (typeof document === "undefined") return content;
  return createPortal(content, document.body);
}
